<header>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="flex sb">
          <a routerLink="/" class="logo"></a>
          <div class="info" (click)="toggle()">
            <i class="icon-info"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
